export const MAIN = 'MAIN';
export const SIDEBAR = 'SIDEBAR';

export const PIN_LOGIN = {
  EXIT: 'PIN_LOGIN_EXIT',
};

export const SIDEBAR_ITEMS = {
  HOME: 'HOME_SIDEBAR',
  LIVE: 'LIVE_SIDEBAR',
  ON_DEMAND: 'ON_DEMAND_SIDEBAR',
  SPORTS: 'SPORTS_SIDEBAR',
  KIDS: 'KIDS_SIDEBAR',
  MY_LIST: 'MY_LIST_SIDEBAR',
  MY_PAGE: 'MY_PAGE_SIDEBAR',
  SEARCH: 'SEARCH_SIDEBAR',
  PROFILE: 'PROFILE_SIDEBAR',
  SETTING: 'SETTING_SIDEBAR',
  EXIT: 'EXIT_SIDEBAR',
};

export const ROUTES = {
  HOME: 'HOME_ROUTE',
  LIVE: 'LIVE_ROUTE',
  ON_DEMAND: 'ON_DEMAND_ROUTE',
  SPORTS: 'SPORTS_ROUTE',
  KIDS: 'KIDS_ROUTE',
  SEARCH: 'SEARCH_ROUTE',
  PROFILE: 'PROFILE_ROUTE',
  SETTING: 'SETTING_ROUTE',
  FEATURE_CAROUSEL: 'FEATURE_CAROUSEL_ROUTE',
};

export const COMPONENTS = {
  PLAYER: 'PLAYER_COMPONENT',
  PROGRESS_BAR: 'PROGRESS_BAR_COMPONENT',
  ERROR_SCREEN: 'ERROR_SCREEN_COMPONENT',
  TRACK_BUTTON: 'TRACK_BUTTON_COMPONENT',
  MINI_EPG_BUTTON: 'MINI_EPG_BUTTON_COMPONENT',
  TAPPP_BUTTON: 'TAPPP_BUTTON',
  GO_LIVE_BUTTON: 'GO_LIVE_BUTTON_COMPONENT',
  TRACK_ITEM: 'TRACK_ITEM',
  SUBTITLE: 'SUBTITLE_COMPONENT',
  NEXT_EPISODE: 'NEXT_EPISODE_BUTTON',
  MINI_EPG_CARD: 'MINI_EPG_CARD_COMPONENT',
  TABS_LIST: 'TABS_LIST_COMPONENT',
  EPG: 'EPG_COMPONENT',
  EPG_FILTER_LIST: 'EPG_FILTER_LIST',
  MINI_EPG_FILTER_LIST: 'MINI_EPG_FILTER_LIST',
  ARE_YOU_STILL_WATCHING_BUTTON: 'ARE_YOU_STILL_WATCHING_BUTTON_COMPONENT',
  BACK_TO_START: 'BACK_TO_START',
  KEY_MOMENTS_CAROUSEL: 'KEY_MOMENTS_CAROUSEL_COMPONENT',
};

export const SETTINGS = {
  EXIT: 'EXIT_SETTINGS',
  OPEN_TERMS_AND_CONDITIONS: 'OPEN_TC_SETTINGS',
  OPEN_PRIVACY_POLICY: 'OPEN_PP_SETTINGS',
};

export const CONFIRMATION = {
  ACCEPT: 'ACCEPT_CONFIRMATION',
};

export const SEARCH = {
  SEARCH_RESULTS: 'SEARCH_RESULTS',
  CUSTOM_SEARCH: 'CUSTOM_SEARCH',
  PRE_SEARCH: 'PRE_SEARCH',
  INPUT_SEARCH: 'INPUT_SEARCH',
};
